/**
 * Ajaxinate — infinite scroll / load more for collection grids.
 * https://github.com/Elkfox/Ajaxinate (MIT). Theme fixes:
 * - readyState/status check (minified build had broken conditions)
 * - ajaxinate-items always inits when #AjaxinateLoop exists (not only when children.length > 0)
 */
(function () {
  'use strict';

  function Ajaxinate(config) {
    this.settings = Object.assign(
      {
        method: 'scroll',
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        offset: 0,
        loadingText: 'Loading',
        callback: null,
      },
      config || {}
    );

    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.preventMultipleClicks = this.preventMultipleClicks.bind(this);
    this.removeClickListener = this.removeClickListener.bind(this);
    this.removeScrollListener = this.removeScrollListener.bind(this);
    this.removePaginationElement = this.removePaginationElement.bind(this);
    this.destroy = this.destroy.bind(this);
    this.loadMore = this.loadMore.bind(this);

    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);
    this.initialize();
  }

  Ajaxinate.prototype.initialize = function () {
    if (!this.containerElement) return;
    if (this.settings.method === 'click') {
      this.addClickListener();
    } else {
      this.addScrollListeners();
    }
  };

  Ajaxinate.prototype.addScrollListeners = function () {
    if (!this.paginationElement) return;
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  };

  Ajaxinate.prototype.addClickListener = function () {
    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener('click', this.preventMultipleClicks);
    }
  };

  Ajaxinate.prototype.preventMultipleClicks = function (e) {
    e.preventDefault();
    if (!this.clickActive) return;
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  };

  Ajaxinate.prototype.checkIfPaginationInView = function () {
    if (!this.paginationElement) return;
    const top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
    const bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector('a');
      this.removeScrollListener();
      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.innerText = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadMore();
      }
    }
  };

  Ajaxinate.prototype.loadMore = function () {
    const self = this;
    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = function () {
      if (self.request.readyState !== 4) return;
      if (self.request.status !== 200) {
        if (self.settings.method === 'click') self.clickActive = true;
        return;
      }
      if (!self.request.responseXML) return;

      const containerNodes = self.request.responseXML.querySelectorAll(self.settings.container);
      const paginationNodes = self.request.responseXML.querySelectorAll(self.settings.pagination);
      const newContainer = containerNodes[0];
      const newPagination = paginationNodes[0];

      if (!newContainer) {
        self.removePaginationElement();
        return;
      }

      self.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);

      if (!newPagination) {
        self.removePaginationElement();
      } else {
        self.paginationElement.innerHTML = newPagination.innerHTML;
        if (typeof self.settings.callback === 'function') {
          self.settings.callback(self.request.responseXML);
        }
        self.initialize();
      }
    };
    this.request.open('GET', this.nextPageUrl);
    this.request.responseType = 'document';
    this.request.send();
  };

  Ajaxinate.prototype.removeClickListener = function () {
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.removeEventListener('click', this.preventMultipleClicks);
    }
  };

  Ajaxinate.prototype.removePaginationElement = function () {
    if (this.paginationElement) {
      this.paginationElement.innerHTML = '';
    }
    this.destroy();
  };

  Ajaxinate.prototype.removeScrollListener = function () {
    document.removeEventListener('scroll', this.checkIfPaginationInView);
    window.removeEventListener('resize', this.checkIfPaginationInView);
    window.removeEventListener('orientationchange', this.checkIfPaginationInView);
  };

  Ajaxinate.prototype.destroy = function () {
    if (this.settings.method === 'click') {
      this.removeClickListener();
    } else {
      this.removeScrollListener();
    }
    return this;
  };

  if (!customElements.get('ajaxinate-items')) {
    customElements.define(
      'ajaxinate-items',
      class extends HTMLElement {
        connectedCallback() {
          this.init();
        }

        init() {
          this.unload();
          const id = this.dataset.ajaxinateId;
          if (!id) return;

          const containerSel = '#AjaxinateLoop[data-ajaxinate-id="' + id + '"]';
          const paginationSel = '#AjaxinatePagination[data-ajaxinate-id="' + id + '"]';

          if (!document.querySelector(containerSel)) return;

          this.endlessScroll = new Ajaxinate({
            container: containerSel,
            pagination: paginationSel,
            method: this.dataset.ajaxinateMethod || 'scroll',
          });
        }

        reinit() {
          this.unload();
          this.init();
        }

        unload() {
          if (this.endlessScroll) {
            this.endlessScroll.settings.method = 'scroll';
            this.endlessScroll.destroy();
            this.endlessScroll = null;
          }
        }

        disconnectedCallback() {
          this.unload();
        }
      }
    );
  }
})();
